module.exports = __webpack_public_path__ + "static/img/01.cdb0cc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour5/01.jpg
// module id = Z+Wd
// module chunks = 0